import { Routes } from 'config/routes';

const MENU_KEY_MAPPINGS: Record<string, string[]> = {
  profile: [Routes.Profile],
  users: [Routes.Users, Routes.Invitations],
  requests: [Routes.Requests],
  locations: [Routes.Locations],
  donors: [Routes.Donors],
  labwork: [Routes.Labwork],
  ['dvm-exam']: [Routes.DvmExam],
  owners: [Routes.Owners],
  donations: [Routes.Donations],
  products: [Routes.Products],
  reports: [Routes.Reports],
  orders: [Routes.Orders],
  dashboards: [Routes.Dashboards],
  settings: [Routes.Settings],
};

const MAPPED_ENTRIES = Object.entries(MENU_KEY_MAPPINGS);
const ALL_ROUTES = Object.values(Routes) as string[];

export const getSelectedMenuKey = (pathname: string): string[] => {
  const mappedKeys = MAPPED_ENTRIES.filter(([, paths]) =>
    paths.some((route) => pathname.startsWith(route))
  ).map(([key]) => `/${key}`);

  const matchedRoutes = ALL_ROUTES.filter(
    (route) => route !== '/' && pathname.startsWith(route)
  );

  return Array.from(new Set([pathname, ...mappedKeys, ...matchedRoutes])).sort(
    (a, b) => b.length - a.length
  );
};
